
import { useTranslation } from 'react-i18next';

export default function AuroraCTASection() {
  const { t, i18n } = useTranslation();
  
  // 言語に応じてリンクを切り替え
  const detailsLink = i18n.language === 'ja' 
    ? 'https://aurora-card.com/jp/?userRef=DP1121'
    : 'https://aurora-card.com/?userRef=DP1121';
  
  return (
    <section className="py-20 bg-gradient-to-br from-purple-900 via-blue-900 to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          <h2 className="text-3xl md:text-5xl font-bold text-white">
            {t('aurora.cta.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {t('aurora.cta.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-6">
            <a 
              href="https://app.aurora-card.com/signup?userRef=DP1121"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-purple-600 hover:bg-purple-700 text-white px-10 py-5 rounded-lg font-bold text-xl transition-all shadow-2xl hover:shadow-purple-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bank-card-line mr-2"></i>
              {t('aurora.cta.button.apply')}
            </a>
            <a 
              href={detailsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-700 hover:bg-gray-600 text-white px-10 py-5 rounded-lg font-bold text-xl transition-all shadow-2xl hover:shadow-gray-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              {t('aurora.cta.button.details')}
            </a>
          </div>

          {/* カスタマーサポート情報 */}
          <div className="mt-16 bg-gray-900/50 backdrop-blur-sm rounded-xl p-8 border border-gray-700 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center justify-center">
              <i className="ri-customer-service-2-line text-3xl text-purple-400 mr-3"></i>
              {t('aurora.cta.support.title')}
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="text-left">
                <p className="text-gray-400 mb-2">{t('aurora.cta.support.telegram')}</p>
                <a 
                  href="https://t.me/Aurora_Card_Support_Bot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 hover:text-blue-300 transition-colors break-all cursor-pointer"
                >
                  <i className="ri-telegram-line mr-2"></i>
                  Aurora Card Support Bot
                </a>
              </div>
              <div className="text-left">
                <p className="text-gray-400 mb-2">{t('aurora.cta.support.email')}</p>
                <a 
                  href="mailto:support@aurora-card.com"
                  className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line mr-2"></i>
                  support@aurora-card.com
                </a>
              </div>
            </div>
          </div>

          {/* 免責事項 */}
          <div className="mt-12 bg-yellow-900/20 border border-yellow-700 rounded-xl p-6 max-w-4xl mx-auto">
            <h4 className="text-lg font-bold text-yellow-400 mb-3 flex items-center justify-center">
              <i className="ri-alert-line text-xl mr-2"></i>
              {t('aurora.cta.disclaimer.title')}
            </h4>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('aurora.cta.disclaimer.text')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
